/**
 * @module app.cd
 */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule, DynamicViews } from 'app/shared/config/modules';
import { getClientDataQuestionTypes } from 'app/cd/components/assessments/question-types';
import { IAppRouteConfig } from 'app/shared/config/router-types';

@autoinject
export class ClientDataModule extends AppModule {

    public readonly code = 'cd';

    constructor(private readonly logger: AppLogger) {
        super();

        logger.source = this;
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['cd'];
    }

    public getRoutes(): IAppRouteConfig[] {
        return [
            { route: ['cd/provider/:providerId/summary', 'cd/provider/location/:locationId?/summary'], name: 'cd.provider.summary', moduleId: PLATFORM.moduleName('app/cd/pages/summary/provider-summary-page'), title: 'cd.provider.summary', activationStrategy: 'invoke-lifecycle', settings: { topic: 'cd.provider-summary' } },
            { route: ['cd/member/:memberId/summary', 'cd/member/plan/:planId?/summary'], name: 'cd.member.summary', moduleId: PLATFORM.moduleName('app/cd/pages/summary/member-summary-page'), title: 'cd.member.summary', activationStrategy: 'invoke-lifecycle', settings: { topic: 'cd.member-summary' } },
            { route: 'cd/auth/:authId/summary', name: 'cd.auth.summary', moduleId: PLATFORM.moduleName('app/cd/pages/summary/auth-summary-page'), title: 'cd.auth.summary', activationStrategy: 'invoke-lifecycle', settings: { topic: 'cd.auth-summary' } },
            { route: 'cd/claim/:claimId/summary', name: 'cd.claim.summary', moduleId: PLATFORM.moduleName('app/cd/pages/summary/claim-summary-page'), title: 'cd.claim.summary', activationStrategy: 'invoke-lifecycle', settings: { topic: 'cd.claim-summary' } }
        ];
    }

    public getDynamicViews(scope: string): DynamicViews {
        if(scope === 'Core.AssessmentQuestionType') {
            return getClientDataQuestionTypes();
        }
        return {};
    }

}
